import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../components';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { LisAddTestItemForm } from './LisAddTestItemForm';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BASE_URL } from '../../../../../utils';
import axios from 'axios';

const initialtestDataObj = {
  data: [],
  loading: false
};
export const LisTestMaster = () => {
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [testList, setTestList] = useState([]);
  const [openTestListDialog, setOpenTestListDialog] = useState(false);
  const [maingroupdropdown, setMaingroupdropdown] = useState([]);
  const [subgroupdropdown, setSubgroupdropdown] = useState([]);
  const [itemnamedropdown, setItemnamedropdown] = useState([]);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [testDataObj, setTestDataObj] = useState(initialtestDataObj);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [activeTab, setActiveTab] = useState(0);
  const [editorData, setEditorData] = useState('');
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState([]);
  const [testMasterFilter, setTestMasterFilter] = useState([]);

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
    console.log({ data });
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        test_name: Yup.string().required('Test Name  Is Required '),
        main_group: Yup.string().required('Main Group  Is Required '),
        charge: Yup.string().required('Charge  Is Required '),
        sub_group: Yup.string().required('Sub Group Is Required ')
      })
    ),
    defaultValues: {
      min_charge: 0,
      max_charge: 0
    },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      console.log('HELLO SELECTED RECORD', selectedRecord);
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['test_item_name', '_id', '__v', 'createdAt', 'status']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setTestList(selectedRecord.test_item_name);
      setEditorData(selectedRecord?.editorContent);
    } else {
      reset();
    }
  }, [selectedRecord, setValue, reset]);

  const getmaingroupdropdown = useCallback(async () => {
    const data = await dropdownFetch('test-main-group');
    setMaingroupdropdown(data);
  }, []);

  const getSubGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('test-sub-group');
    setSubgroupdropdown(data);
  }, []);


  const getTestItemDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test-item');
    setItemnamedropdown(data);
    console.log(itemnamedropdown, 'Hello Dropcdhch');
  }, []);

  useEffect(() => {
    getmaingroupdropdown();
    getSubGroupDropdown();
    getTestItemDropdown();
  }, [getmaingroupdropdown, getSubGroupDropdown, getTestItemDropdown]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const payload = {
      ...formValues,
      editorContent: editorData,
      test_item_name: testList.map((data) => ({
        res_formula: data.res_formula,
        test_item_name: data.test_item_name,
        name: data.name
      }))
    };
    const response = await request(editFlag ? '/lis-test-update' : '/lis-test-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: payload
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Test Master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
      setTestList([]);
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Test Master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/lis-test-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Test master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Test master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setTestDataObj({ loading: true });
    const response = await axios.get(`${BASE_URL}/lis-test/list?limit=${10}`);
    if (response?.data?.success) {
      setTestDataObj({ loading: false, data: response.data?.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setTestDataObj({ loading: false });
    }
  };

  const TEST_HEADER = [
    {
      header: 'Item Name',
      accessor: 'name',
      sx: { textTransform: 'capitalize' }
    },

    {
      header: 'Res. Formula',
      accessor: 'res_formula'
    }
  ];

  const TABLE_COLUMNS = [
    { header: 'Test Name ', accessor: 'test_name' },
    { header: 'Sub Group', accessor: (row) => row?.sub_group?.sub_group },
    { header: 'Main Group', accessor: (row) => row?.main_group?.main_group },
    { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } },
    { header: 'Created At', accessor: 'createdAt' }
  ];

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  useEffect(() => {
    handleTestSearch();
  }, [input]);

  const handleTestSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
  
      try {
        const response = await request('/lis-test-list', {
          method: 'GET',
          query: { test_name: lowercasedInput }
        });
        if (response.success && Array.isArray(response.data)) {
          setTestDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setTestDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setTestDataObj({ loading: false, data: [] });
      }

  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Test Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setTestList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={handleSubmit(formSubmit)}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>

            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '80%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Button
                variant="contained"
                onClick={() => handleActiveTab(0)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700
                }}
              >
                Main
              </Button>
              <Button
                variant="contained"
                onClick={() => handleActiveTab(1)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700
                }}
              >
                Interpretation
              </Button>
              <Grid container spacing={4}>
                {activeTab === 0 && (
                  <>
                    <Grid item xs={7} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, marginTop: '1%' }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Test Name</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="test_name"
                          placeholder="Enter Test  Name"
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Test Code</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="test_code"
                          placeholder="Enter Test Code"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Main Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.3 }}
                          name="main_group"
                          placeholder=" Select Main Group"
                          menus={maingroupdropdown.map((data) => ({ ...data, name: data.main_group }))}
                        />
                        <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Sub Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.3 }}
                          name="sub_group"
                          placeholder="Select Sub Group"
                          menus={subgroupdropdown.map((data) => ({ ...data, name: data.sub_group }))}
                        />
                      </Stack>
                      <Stack spacing={0.2} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.24, fontWeight: 700, fontSize: '1.4rem' }}>Charge</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.35, border: currentAction ? '0.5px solid red' : '' }}
                          name="charge"
                          placeholder="Charge"
                        />
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Min/Max Charge</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.15 }}
                          name="min_charge"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.15 }}
                          name="max_charge"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Button
                        onClick={() => setOpenTestListDialog(true)}
                        variant="contained"
                        sx={{ width: '20%', justifyContent: 'space-between' }}
                        disabled={!['edit', 'new'].includes(currentAction) || loading}
                      >
                        Add Item
                      </Button>
                      <Table
                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                        data={testList}
                        columns={TEST_HEADER}
                        size="medium"
                        showDeleteAction={true}
                        onDeleteHandler={(id) => {
                          setTestList(testList.filter(({ _id }) => _id !== id));
                        }}
                      />
                    </Grid>
                  </>
                )}
                {activeTab === 1 && (
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <CKEditor
                      editor={ClassicEditor}
                      data={editorData}
                      onReady={(editor) => {
                        console.log('Editor is ready to use!', editor);
                      }}
                      onChange={handleEditorChange}
                      onBlur={(event, editor) => {
                        console.log('Blur.', editor);
                      }}
                      onFocus={(event, editor) => {
                        console.log('Focus.', editor);
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog open={openTestListDialog} onClose={() => setOpenTestListDialog(false)} scroll="body" maxWidth="xl">
        <LisAddTestItemForm
          onClose={() => setOpenQueryDialog(false)}
          onAdd={(data) => {
            const [existingDetail] = testList.filter(({ item }) => item === data.test_item_name);
            if (existingDetail) {
              toast('Test Item Name already chosen', { variant: 'error' });
              return;
            }
            const testItemName = itemnamedropdown.filter(({ _id }) => _id === data.test_item_name)[0]?.test_item_name;
            setTestList((prev) => [...prev, { ...data, _id: data.test_item_name, name: testItemName }]);
            console.log('HELLLO TEST ITEM NAME', testList);
          }}
          testItemDropdown={itemnamedropdown}
        />
      </Dialog>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Test Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Service"
            variant="outlined"
            value={input}
            onChange={handleInputChange}
            InputProps={{
              style: {
                fontSize: '12px',
                fontWeight: 600
              }
            }}
          />
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TABLE_COLUMNS}
          data={testDataObj.data || []}
          loading={testDataObj.loading}
          onRowClick={(row) => {
            const { test_item_name, sub_group, main_group, category, ...others } = row;
            const findTestItemNameById = (id) => {
              const foundItem = itemnamedropdown.find((item) => item._id === id);
              return foundItem ? foundItem.test_item_name : undefined;
            };
            const updatedTestItemName = test_item_name?.map((data) => {
              const name = findTestItemNameById(data?.test_item_name);
              return {
                ...data,
                _id: data.test_item_name,
                name: name
              };
            });
            setSelectedRecord({
              ...others,
              sub_group: sub_group?._id,
              main_group: main_group?._id,
              category: category?._id,
              test_item_name: updatedTestItemName
            });
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
